import { createMemoStyles } from '@wds/utils';
import { HeaderTheme } from '../../theme';

type NavButtonStyleProps = {
  active?: boolean;
};

const useNavButtonStyles = createMemoStyles(
  ({ palette, spacing, type }: HeaderTheme) => ({
    navButton: ({ active }: NavButtonStyleProps) => ({
      boxSizing: 'border-box',
      fontWeight: type.fontWeight.medium,
      fontFamily: type.fontFamily.base,
      fontSize: type.fontSize.bodySm,
      '-webkit-font-smoothing': 'antialiased',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      position: 'relative',
      borderRadius: 0,
      border: 'none',
      boxShadow: 'none',
      background: 'none',
      textDecoration: 'none',
      color: palette.text.light,
      borderBottom: active ? 'solid 4px #fff' : 'solid 4px transparent',
      borderTop: 'solid 4px transparent',
      margin: [0, spacing[4]],
      padding: 0,
      height: 48,

      '&:hover, &:focus': {
        borderBottom: 'solid 4px #fff',
        textDecoration: 'none',
      },
    }),
  })
);

export default useNavButtonStyles;
